module.exports = __webpack_public_path__ + "assets/img/img299.a69f0321.png";